export default "__VITE_ASSET__DG2Ha_lR__"